import { PawPrint, ShoppingBag } from "lucide-react";
import { useStore } from "../../context/StoreContext";

const LINKS = [
  { href: "#problema", label: "The problem" },
  { href: "#demo", label: "How it works" },
  { href: "#beneficios", label: "Benefits" },
  { href: "#packs", label: "Packs" },
  { href: "#faq", label: "FAQ" },
];

export const Header = () => {
  const { setCartOpen, selectedPack } = useStore();
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-zinc-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-brand flex items-center justify-center">
            <PawPrint className="w-4 h-4 text-white" />
          </span>
          <span className="font-display font-bold text-lg tracking-tight">PeloCero</span>
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="text-sm text-zinc-500 hover:text-ink transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          data-testid="header-cart-button"
          onClick={() => setCartOpen(true)}
          className="relative flex items-center gap-2 text-sm font-semibold border border-zinc-200 rounded-full px-4 py-2 hover:border-ink transition-colors"
        >
          <ShoppingBag className="w-4 h-4" />
          <span className="hidden sm:inline">Order</span>
          {selectedPack && (
            <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-brand text-white text-[10px] font-bold flex items-center justify-center">
              {selectedPack.units}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};
